import useSWR from "swr";
import ApiClient from "../../backends/ApiClient";
import { GridTypes } from "../../utils/SchoolBlocksUtilities";
import {
  getSubBlocks,
  IProcessedGroupSubBlock,
} from "../../components/blocks/SchoolBlocks/GroupBlock/GroupBlock";

async function fetchPageBlockPreview(organizationId: string): Promise<{
  blocks: IProcessedGroupSubBlock[];
  type: string;
}> {
  const client = await ApiClient();
  const blockObj = await client.GET("/blocks/{id}/", {
    params: { path: { id: organizationId } },
  });

  return {
    // @ts-ignore
    blocks: getSubBlocks(blockObj.subBlocks),
    // @ts-ignore
    type: blockObj.blockModel.json_data?.terracedGrid?.enabled
      ? GridTypes.terraced
      : GridTypes.packery,
  };
}

export function usePageBlockPreview(organizationId: string | null) {
  const { data, isLoading } = useSWR(
    organizationId ? `page-block-preview-${organizationId}` : null,
    () => fetchPageBlockPreview(organizationId as string),
    {
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
    },
  );

  return { data: data ?? { blocks: [], type: "" }, isLoading };
}
